export default "__VITE_ASSET__DiJKrXH1__"